import React from "react";
import HomePageContent from "../functional-components/HomePageContent/HomePageContent.jsx";
import Capabilities from "../functional-components/Capabilities/Capabilities.jsx";

const CapabilitiesPage = () => {
  return (
    <div>
      <Capabilities />
    </div>
  );
};

export default CapabilitiesPage;
